import { render, staticRenderFns } from "./BankBalanceCards.vue?vue&type=template&id=c0bbfc5e&"
import script from "./BankBalanceCards.vue?vue&type=script&lang=js&"
export * from "./BankBalanceCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports